import Vue from 'vue'
import Router from 'vue-router'

//Vuex Store
import {store} from '../store/store'


// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

//Fportal
const DossierFournisseur = () => import('@/views/fportal/dossier-fournisseur/DossierFournisseur')
const Contact = () => import('@/views/fportal/contact/Contact')
const Profile = () => import('@/views/fportal/profile/Profile')
const Messages = () => import('@/views/fportal/messages/Messages')
const Bons = () => import('@/views/fportal/bons/Bons')
const Consultations = () => import('@/views/fportal/consultations/Consultations')


// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')
const VerifyMail = () => import('@/views/pages/VerifyMail')
const ForgotPassword = () => import('@/views/pages/ForgotPassword')
const ResetPassword = () => import('@/views/pages/ResetPassword')
const Home = () => import('@/views/pages/Home')
const AppelOffres = () => import('@/views/pages/AppelOffres')

Vue.use(Router)

export default new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  // base:'partners',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/pages/home',
      name: 'Accueil',
      component: DefaultContainer,
      beforeEnter(to, from, next){
        if(store.getters.isAuthenticated){
          next()
        }
        else{
          next('/pages/login')
        }
      },
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'mon-dossier',
          name: 'DossierFournisseur',
          component: DossierFournisseur
        },
        {
          path: 'messages',
          name: 'Messages',
          component: Messages
        },
        {
          path: 'bons',
          name: 'Bons',
          component: Bons
        },
        {
          path: 'consultations',
          name: 'Consultations',
          component: Consultations
        },
      ]
    }, 
    {
      path: '*',
      redirect:'/pages/404'
    },
    {
      path: '/pages',
      redirect: '/pages/home',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: 'contact',
          name: 'Contact',
          component: Contact
        },
        {
          path: 'appel-offres',
          name: 'AppelOffres',
          component: AppelOffres
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login,
          beforeEnter(to, from, next){
            if(!store.getters.isAuthenticated){
              next()
            }
            else{
              next('/dashboard')
            }
          }
        },
        {
          path: 'register',
          name: 'Register',
          component: Register,
          beforeEnter(to, from, next){
            if(!store.getters.isAuthenticated){
              next()
            }
            else{
              next('/mon-dossier')
            }
          }
        },
        {
          path: 'profile',
          name: 'Profile',
          component: Profile,
          beforeEnter(to, from, next){
            if(store.getters.isAuthenticated){
              next()
            }
            else{
              next('/pages/login')
            }
          }
        },
        {
          path: 'home',
          name: 'Home',
          component: Home,
          
        },
        {
          path: 'verify-email/:token',
          name: 'Verify Mail',
          component: VerifyMail,
          
        },
        {
          path: 'forgot-password',
          name: 'Mot de passe Oublié',
          component: ForgotPassword,
        },
        {
          path: 'reset-password/:token',
          name: 'Nouveau Mot de passe',
          component: ResetPassword,
        }
      ]
    }
  ]
})
